import { Input } from 'antd';
import { Tooltip } from '@mantine/core';
import React, { useState, useRef, useMemo } from 'react';
import { editFlowLbabel } from '@starflow/app/helpers/flow';
import { NodeState } from '../../../constants';
import { isGtLen } from '../../../utils';

const FlowLabelEditor = ({ flow }) => {
  const [value, setValue] = useState(flow.data.title);
  const refs = useRef();

  const onBlur = () => {
    editFlowLbabel(flow.flowId, value);
  };

  const isTextEditing = useMemo(() => {
    const state = flow?.state ?? [];
    const flag = state.some((s) => s === NodeState.TextEditing);
    if (flag) {
      setTimeout(() => {
        refs.current?.focus();
        refs.current?.select();
      }, 200);
    }

    return flag;
  }, [flow?.state?.length]);

  return isTextEditing ? (
    <Input
      onMouseDown={(e) => e.stopPropagation()}
      onMouseMove={(e) => e.preventDefault()}
      style={{ borderWidth: 0, boxShadow: '0 0 0 0', textAlign: 'center' }}
      ref={refs}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={() => onBlur()}
      onKeyUp={(e) => e.keyCode === 13 && onBlur()}
    />
  ) : (
    <>
      {isGtLen(flow.data.title) ? (
        <Tooltip withArrow position="top" offset={10} className="scale-90" label={flow.data.title}>
          <span className="overflow-ellipsis overflow-hidden whitespace-nowrap w-[130px] text-center leading-[30px]">
            {flow.data.title}
          </span>
        </Tooltip>
      ) : (
        flow.data.title
      )}
    </>
  );
};
export default FlowLabelEditor;
